import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=362c9c18&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362c9c18')) {
      api.createRecord('362c9c18', component.options)
    } else {
      api.reload('362c9c18', component.options)
    }
    module.hot.accept("./twitter.vue?vue&type=template&id=362c9c18&", function () {
      api.rerender('362c9c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/twitter.vue"
export default component.exports